module.exports = __webpack_public_path__ + "static/media/check-green.cfedd3be.svg";